export default __webpack_public_path__ + "static/color-alpha-palette-light-1ca85560844de1c631d7886ab355aa99b6a991aa2290470d5da201a76c8de734.png";